let inject = ['$scope', '$uibModalInstance','modalOptions','CategoryProductsService'];

class ModalAtributosController {
  constructor ($scope,$uibModalInstance,modalOptions,CategoryProductsService) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
	this.CategoryProductsService = CategoryProductsService;
  }
  
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok(atributo) {
    this.$uibModalInstance.close(atributo);
  }
}

ModalAtributosController.$inject = inject;

export default ModalAtributosController;



// WEBPACK FOOTER //
// ./www/components/catalog/products-list/modal-atributos/modal-atributos.controller.js